import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const US_DATE_FORMAT = 'DD MMM YYYY';
export const US_SHORT_DATE_FORMAT = 'DD MMM';

export function getUtcDateTime() {
  return dayjs.utc();
}

export function formatToUtcDate(date: Date | string | Dayjs) {
  return dayjs.utc(date).toISOString();
}

export function getUtcDate(date: Date | string | Dayjs) {
  return dayjs.utc(date);
}

export function getFormattedUtcDateTime(date: Date | string | Dayjs) {
  return dayjs.utc(date).format(`${US_DATE_FORMAT}, h:mma`);
}

export function getUSTimeFormat(
  date: Date | string | Dayjs,
  isLongDateFormat = true,
  isUtc = false
) {
  const format = isLongDateFormat ? US_DATE_FORMAT : US_SHORT_DATE_FORMAT;

  if (isUtc) {
    return getUtcDate(date).format(format);
  }

  return dayjs(date).format(format);
}

export function getStartOfDate(date: Dayjs | string | Date) {
  return dayjs(date)
    .set('hour', 0)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0);
}

export function getCurrentUtcFormattedDate(date?: string) {
  if (!date) return undefined;

  // Get current date in format DD-MM-YYYY
  const currentDate = new Date(date);
  const day = currentDate.getDate().toString().padStart(2, '0');
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const year = currentDate.getFullYear();

  return `${year}-${month}-${day}T00:00:00Z`;
}
